import { RootState } from '../models';

export const selectIsPaused = (state: RootState) => {
	const isPaused = state.data.isLoaded ? state.video.isPaused : false;
	return isPaused;
};
